import type { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'

interface HttpAuthAdapter {
  getAccessToken(): string | null
  getValidAccessToken?(): Promise<string | null>
  refreshAccessToken(): Promise<string | null>
  onSessionExpired(): void
}

let adapter: HttpAuthAdapter | null = null
let refreshPromise: Promise<string | null> | null = null

export function configureHttpAuth(nextAdapter: HttpAuthAdapter): void {
  adapter = nextAdapter
}

export function attachAuthInterceptors(client: AxiosInstance): void {
  // 1. Request interceptor: Chủ động lấy token hợp lệ (hoặc tự refresh trước nếu token sắp hết hạn)
  client.interceptors.request.use(async (config) => {
    let token: string | null = null
    if (adapter?.getValidAccessToken) {
      token = await adapter.getValidAccessToken()
    } else {
      token = adapter?.getAccessToken() ?? null
    }
    if (token) config.headers.set('Authorization', `Bearer ${token}`)
    return config
  })

  // 2. Response interceptor: Lớp phòng vệ thứ hai khi server vẫn từ chối 401
  client.interceptors.response.use(undefined, async (error: AxiosError) => {
    const request = error.config as (InternalAxiosRequestConfig & { _retried?: boolean }) | undefined
    if (!adapter || error.response?.status !== 401 || !request || request._retried) {
      throw error
    }

    request._retried = true
    refreshPromise ??= adapter.refreshAccessToken().finally(() => {
      refreshPromise = null
    })

    const token = await refreshPromise
    if (!token) {
      adapter.onSessionExpired()
      throw error
    }

    request.headers.Authorization = `Bearer ${token}`
    return client(request)
  })
}
